// extracted by mini-css-extract-plugin
module.exports = {"root":"tag__root--3VUZg","tag":"tag__tag--2RvHb"};